const unrestrictedCountries = {
  US: "United States",
  CA: "Canada",
  MX: "Mexico",
  GB: "United Kingdom", // Enable Auto SO creation for UK - 04/06/2025
  CH: "Switzerland", // Enable Auto SO creation for Switzerland - 24/06/2025
  IL: "Israel", // Enable Auto SO creation for Israel - 01/07/2025
  JP: "Japan", // Enable Auto SO creation for Japan - 18/07/2025
  SG: "Singapore", // Enable Auto SO creation for Singapore - 18/07/2025
};
export default unrestrictedCountries;
